import { render, staticRenderFns } from "./buyer-details.vue?vue&type=template&id=95577a3a&"
import script from "./buyer-details.vue?vue&type=script&lang=js&"
export * from "./buyer-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports